import '@99designs/common/jquery-plugins/tooltip';
import { trackEvent } from '@99designs/common/utils/platform';
import { scrollToElement } from 'common/utils/scroll';
import 'lazysizes';
import shave from 'shave';
import EmailCaptureForm from './components/EmailCaptureForm';
import LikeableDesign from './components/LikeableDesign';

document.addEventListener('DOMContentLoaded', () => {
    initDesignCards();
    shave('[data-ellipsize]', 100);
    initLikeableDesigns();
    initShowMoreItems();
    initSubscribeCTA();
    initEmailCaptureForm();
    // @ts-ignore
    jQuery('[data-tooltip]').tooltip({ location: 'up-center' });
});

function initEmailCaptureForm() {
    const emailCollectorForm = document.querySelector<HTMLElement>('[data-email-collector]');

    if (!emailCollectorForm) {
        return;
    }

    // tslint:disable-next-line:no-unused-expression
    new EmailCaptureForm(emailCollectorForm, {
        withRecaptcha: true,
        emailFieldName: 'email_address',
    });
}

function initDesignCards() {
    const designCards = document.querySelectorAll<HTMLElement>('[data-design-card]');
    for (var i = 0; i < designCards.length; i++) {
        designCards[i].style.visibility = 'visible';
    }
}

function initLikeableDesigns() {
    const designs = Array.from(document.querySelectorAll<HTMLElement>('[data-likeable-design]'));

    designs.forEach(design => {
        LikeableDesign.create(design);
    });
}

function initShowMoreItems() {
    const buttonTrigger = document.querySelector<HTMLElement>('[data-show-more-items-trigger]');
    const endOfScrollCTA = document.querySelector<HTMLElement>('[data-end-of-scroll-cta]');
    const maxNumOfDesignsPerTrigger = 6;

    if (!buttonTrigger || !endOfScrollCTA) {
        return;
    }

    endOfScrollCTA.setAttribute('data-hidden', '');

    buttonTrigger.addEventListener('click', () => {
        const nextItems = hiddenMatrixItems().slice(0, maxNumOfDesignsPerTrigger);
        if (nextItems.length > 0) {
            nextItems.forEach(item => item.removeAttribute('data-show-more-items-hidden'));
            trackEvent('Clicked CTA On Inspiration Page', {
                location: 'show-more-design-cards',
            });
        }

        if (hiddenMatrixItems().length === 0) {
            buttonTrigger.setAttribute('data-hidden', '');
            endOfScrollCTA.removeAttribute('data-hidden');
        }

        shave('[data-ellipsize]', 100);
    });
}

function hiddenMatrixItems() {
    return Array.from(document.querySelectorAll('[data-show-more-items-hidden]'));
}

function initSubscribeCTA() {
    const subscribeCTA = document.querySelector<HTMLElement>('[data-subscribe-cta]');

    if (!subscribeCTA) {
        return;
    }

    subscribeCTA.addEventListener('click', event => {
        event.preventDefault();
        const emailForm = document.querySelector('[data-email-collector]');
        if (emailForm) {
            scrollToElement(emailForm, 150, 1000);
        }
    });
}
